import Vue from 'vue'
import axios from 'axios'
export default {
    state: {
        getUrl() {
            const instance = axios.create({
                // baseURL: 'http://localhost:3000'
                //baseURL: (process.env.NODE_ENV ==='production')?'http://10.2.210.211:30308':'http://localhost:3000'
                // baseURL: 'http://10.2.210.211:30308'
                baseURL: Vue.config['url']
            });
            //instance.defaults.headers.common['Authorization'] = AUTH_TOKEN;
            instance.defaults.headers.common['x-auth-token'] = localStorage.getItem('token');
            instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
            return instance
        }
    },
    maxPromotionID() {
        // return this.state.getUrl().post('/promotion/max-promotion-id')
        return this.state.getUrl().get('/promotion/max-promotion-id')
            .then(function (response) {
                return Promise.resolve(response.data)
            })
            .catch(function (error) {
                return Promise.reject(error.response.data.error)
            });
    },
    createPromotion(promotion) {
        return this.state.getUrl().post('/promotion/create', promotion)
            .then(function (response) {
                return Promise.resolve(response.data)
            })
            .catch(function (error) {
                return Promise.reject(error.response.data.error)
            });
    },
    updatePromotion(promotion) {
        return this.state.getUrl().post('/promotion/update', promotion)
            .then(function (response) {
                return Promise.resolve(response.data)
            })
            .catch(function (error) {
                return Promise.reject(error.response.data.error)
            });
    },
    getCustomerGroups() {
        //return this.state.getUrl().get('/custgroup/get')
        return this.state.getUrl().get('/custgroup/get?customers=false')
            .then(function (response) {
                return Promise.resolve(response.data)
            })
            .catch(function (error) {
                return Promise.reject(error.response.data.error)
            });
    },
    getProductGroups(datas) {
        var filter = (datas && datas.filter) ? datas.filter : '';
        var searchby = (datas && datas.searchby) ? datas.searchby : '';
        // return this.state.getUrl().get('/v1/product-group')
        return axios.get('/v1/product-group?filter=' + filter + '&searchby=' + searchby)
            .then(function (response) {
                return Promise.resolve(response)
            })
            .catch(function (error) {
                return Promise.reject(error)
            });
    },
    getAllProductGroup(datas) {
        var filter = (datas && datas.filter) ? datas.filter : '';
        var searchby = (datas && datas.searchby) ? datas.searchby : '';
        // return this.state.getUrl().get('/v1/get-all-product-group')
        // return this.state.getUrl().get('/v1/get-all-product-group?filter=' + filter + '&searchby=' + searchby)
        return axios.get('/v1/get-all-product-group?filter=' + filter + '&searchby=' + searchby)
            .then(function (response) {
                return Promise.resolve(response)
            })
            .catch(function (error) {
                return Promise.reject(error)
            });
    },
    getPromotions(code, duration) {
        // console.log("- getPromotions -");
        // let emp_code = Vue.$jwt.decode(localStorage.getItem('token')).code;
        let user = Vue.$jwt.decode(localStorage.getItem('token'));
        return this.state.getUrl().get('/promotion/list?not=Delete&code=' + code + '&emp_code=' + user.code + '&duration=' + duration + '&group=' + user.group)
            .then(function (response) {
                return Promise.resolve(response.data)
            })
            .catch(function (error) {
                return Promise.reject(error.response.data.error)
            });
    },
    getPromotionsbycode(code) {
        return axios.get('/promotion/getbycode/' + code)
            .then(function (response) {
                return Promise.resolve(response)
            })
            .catch(function (error) {
                return Promise.reject(error)
            });
    },
    deletePromotion(id) {
        /*return this.state.getUrl().delete('/promotion/delete/'+id)*/
        return this.state.getUrl().post('/promotion/update/')
            .then(function (response) {
                return Promise.resolve(response.data)
            })
            .catch(function (error) {
                return Promise.reject(error.response.data.error)
            });
    },
    ProductTree(id) {
        let emp_code = Vue.$jwt.decode(localStorage.getItem('token')).code;
        // return this.state.getUrl().get('/promotion/producttree/' + id + '?emp_code=' + emp_code)
        return axios.get('/promotion/producttree/' + id + '?emp_code=' + emp_code)
            .then(function (response) {
                return Promise.resolve(response)
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
    ProductTreeFreeItem(id) {
        let emp_code = Vue.$jwt.decode(localStorage.getItem('token')).code;
        return axios.get('/promotion/producttreefreeitem/' + id + '?emp_code=' + emp_code)
            .then(function (response) {
                return Promise.resolve(response)
            })
            .catch(function (error) {
                return Promise.reject(error)
                // return Promise.reject(error.response.data.error)
            });
    },
    ProductImport(datas) {
        let emp_code = Vue.$jwt.decode(localStorage.getItem('token')).code;
        datas.emp_code = emp_code;
        return axios.post('/promotion/product-import', datas)
            .then(function (response) {
                return Promise.resolve(response)
            })
            .catch(function (error) {
                return Promise.reject(error);
                // return Promise.resolve([])
                // return Promise.reject(error.response.data.error)
            });
    },
    getProductUpdate(datas) {
        return this.state.getUrl().post('/promotion/productupdate', datas)
            .then(function (response) {
                return Promise.resolve(response.data)
            })
            .catch(function (error) {
                return Promise.reject(error.response.data.error)
            });
    },
    getCustomerGroupUpdate(datas) {
        return this.state.getUrl().post('/promotion/customergroupupdate', datas)
            .then(function (response) {
                return Promise.resolve(response.data)
            })
            .catch(function (error) {
                return Promise.reject(error.response.data.error)
            });
    },
    Track(datas) {
        return this.state.getUrl().post('/promotion/track', datas)
            .then(function (response) {
                return Promise.resolve(response.data)
            })
            .catch(function (error) {
                return Promise.reject(error.response.data.error)
            });
    },
    UnTrack(datas) {
        return this.state.getUrl().post('/promotion/remove-track', datas)
            .then(function (response) {
                return Promise.resolve(response.data)
            })
            .catch(function (error) {
                return Promise.reject(error.response.data.error)
            });
    },
    getChartBubble(code) {
        return this.state.getUrl().get('/promotion/track-info?user_code=' + code)
            .then(function (response) {
                return Promise.resolve(response.data)
            })
            .catch(function (error) {
                return Promise.reject(error.response.data.error)
            });
    },
    getDefaultPrice() {
        return this.state.getUrl().get('/promotion/get-default-price')
            .then(function (response) {
                return Promise.resolve(response.data)
            })
            .catch(function (error) {
                return Promise.reject(error.response.data.error)
            });
    },
    updateStatusInactivePromo(_id) {
        var id = {
            _id: _id
        }
        return axios.post('/promotion/update-status', id)
            .then(function (response) {
                return Promise.resolve(response)
            })
            .catch(function (error) {
                return Promise.reject(error)
            });
    },
    ReportList(datas) {
        // return this.state.getUrl().get('/promotion/report-list')
        // return this.state.getUrl().post('/promotion/report-list', datas)
        return this.state.getUrl().post('/promotion/report', datas)
            .then(function (response) {
                return Promise.resolve(response.data)
            })
            .catch(function (error) {
                return Promise.reject(error.response.data.error)
            });
    },
    ReportChart(datas) {
        return this.state.getUrl().post('/promotion/report-chart', datas)
            .then(function (response) {
                return Promise.resolve(response.data)
            })
            .catch(function (error) {
                return Promise.reject(error.response.data.error)
            });
    },
    ReportExportItem(datas) {
        return this.state.getUrl().post('/promotion/report-export-item', datas)
            .then(function (response) {
                return Promise.resolve(response.data)
            })
            .catch(function (error) {
                return Promise.reject(error.response.data.error)
            });
    },
    checkProductInactive(product_codes) {
        return this.state.getUrl().post('/promotion/check-product-inactive', {
                product_codes: product_codes
            })
            .then(function (response) {
                return Promise.resolve(response.data)
            })
            .catch(function (error) {
                return Promise.reject(error.response.data.error)
            });
    },
    getAllPromotion(datas) {
        var filter_promotion = (datas && datas.filter_promotion) ? datas.filter_promotion : '';
        // return axios.get('/promotion/get-all-promotion')
        return axios.get('/promotion/get-all-promotion?filter_promotion=' + filter_promotion)
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
    getAllCustomer() {
        return axios.get('/promotion/get-all-customer')
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
    getAllSmCode() {
        return axios.get('/promotion/get-all-sm-code')
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
    getAllProduct(datas) {
        var type = (datas && datas.type) ? datas.type : '';
        var code = (datas && datas.code) ? datas.code : '';
        return axios.get('/promotion/product-hierarchy?type=' + type + '&code=' + code)
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
    getAllProductSearch(datas) {
        let emp_code = Vue.$jwt.decode(localStorage.getItem('token')).code;
        var group = (datas && datas.group) ? datas.group : '';
        var subgroup = (datas && datas.subgroup) ? datas.subgroup : '';
        var cg = (datas && datas.cg) ? datas.cg : '';
        var code = (datas && datas.code) ? datas.code : '';
        var name = (datas && datas.name) ? datas.name : '';
        var searchtype = (datas && datas.searchtype) ? datas.searchtype : '';
        return axios.get('/promotion/product-search?emp_code=' + emp_code + '&code=' + encodeURIComponent(code) + '&name=' + encodeURIComponent(name) + '&group=' + encodeURIComponent(group) + '&subgroup=' + encodeURIComponent(subgroup) + '&cg=' + encodeURIComponent(cg) + '&searchtype=' + searchtype)
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
    getAllPromotionRepeat() {
        return axios.get('/promotion/code')
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
    updateTypeActive(datas) {
        return axios.post('/promotion/update-type-active', datas)
            .then(function (response) {
                return Promise.resolve(response)
            })
            .catch(function (error) {
                return Promise.reject(error)
            });
    },
    filterPromotion(datas) {
        var prodgroup = (datas && datas.prodgroup) ? datas.prodgroup : '';
        var custgroup = (datas && datas.custgroup) ? datas.custgroup : '';
        return axios.get('/promotion/filter-promotion?prodgroup=' + prodgroup + '&custgroup=' + custgroup)
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
    getApproveBy(user) {
        var code = (user && user.code) ? user.code : '';
        var boss_code = (user && user.boss_code) ? user.boss_code : '';
        return axios.get('/user/approveby/' + code + '?boss_code=' + boss_code)
            .then(function (response) {
                return Promise.resolve(response.data);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
    getUserUnderPromortion(bosscode) {
        return axios.get('/promotion/getUserUnder/' + bosscode)
            .then(function (response) {
                return Promise.resolve(response)
            })
            .catch(function (error) {
                return Promise.reject(error)
            });
    },
    getFilterUsercreatePromortion(user) {
        var code = (user && user.code) ? user.code : '';
        var boss_code = (user && user.boss_code) ? user.boss_code : '';
        var user_group = (user && user.group) ? user.group : '';
        return axios.get('/promotion/get-filter-usercreate?code=' + code + '&boss_code=' + boss_code + '&user_group=' + user_group)
            .then(function (response) {
                return Promise.resolve(response)
            })
            .catch(function (error) {
                return Promise.reject(error)
            });
    },
    updateRealPriceList(datas) {
        // var productcode = (datas && datas.product_code) ? datas.product_code : [];
        // var pricetype = (datas && datas.price_type) ? datas.price_type : [];
        // return this.state.getUrl().get('/promotion/get-real-pricelist?product_code=' + productcode + '&price_type=' + pricetype)
        return this.state.getUrl().post('/promotion/update-real-pricelist', datas)
            .then(function (response) {
                return Promise.resolve(response.data)
            })
            .catch(function (error) {
                return Promise.reject(error.response.data.error)
            });
    },
    updateCostConv(datas) {
        // var productcode = (datas && datas.product_code) ? datas.product_code : [];
        // return this.state.getUrl().get('/promotion/get-cost-conv?product_code=' + productcode)
        return this.state.getUrl().post('/promotion/update-cost-conv', datas)
            .then(function (response) {
                return Promise.resolve(response.data)
            })
            .catch(function (error) {
                return Promise.reject(error.response.data.error)
            });
    },
    updatePromotionPrice(datas) {
        return this.state.getUrl().post('/promotion/update-promotion-price', datas)
            .then(function (response) {
                return Promise.resolve(response.data)
            })
            .catch(function (error) {
                return Promise.reject(error.response.data.error)
            });
    },
    getPmStrategy() {
        return axios.get('/promotion/get-strategy')
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
}